import moment from 'moment';
import {useEffect} from 'react';
import SurveyQuestion from '@jobseeker/lotus/components/SurveyQuestion';
import surveyService from '@jobseeker/common-core/services/survey.service';
import {handleTracking} from '@jobseeker/common-core/utils';
import useInterceptor from '@jobseeker/common-core/hooks/useInterceptor';

import type {SurveyQuestionType, SurveyType} from './types';

const Survey = (props: SurveyType) => {
  const {currQuestion, setCurrentQuestion: setCurrQuestion} = props;
  const metadata: any = useInterceptor();

  const hideSurvey = () => {
    props.setShowSurvey(false);
  };

  const submitAnswer = async (answer: string) => {
    if (props.surveyType === 'RelevantJob') {
      const answerObj = JSON.parse(answer);
      handleTracking('jsClickRelevantJobSurvey', {
        event_category: 'Job_recommedation_survey',
        UserId: sessionStorage.getItem('userId') || 'NA',
        Device: sessionStorage.getItem('device') || 'desktop',
        Device_Type: sessionStorage.getItem('deviceType') || 'web',
        Origin: metadata.page,
        Position: props.surveyPosition,
        Date: moment().format('DD/MM/YYYY'),
        Response: answerObj?.buttons || '',
        ReasonCode: answerObj?.chips || '[]',
        Comment: answerObj?.text || '',
      });
    }
    const answerResponse = await surveyService.answerSurveyQuestion({
      source: props.source,
      answer: answer,
      questionId: currQuestion.id,
      surveyId: currQuestion.surveyId,
    });

    try {
      props.successCallback?.();
    } catch (error) {
      console.error('Error in success callback:', error);
    }

    return answerResponse;
  };

  useEffect(() => {
    if (currQuestion?.type === 'noSelect') {
      setTimeout(hideSurvey, 5000);
    }
  }, [currQuestion]);

  const questionsMapping = props?.questions?.reduce(
    (obj: object, item: SurveyQuestionType) =>
      Object.assign(obj, {[item.id]: item}),
    {}
  );

  return (
    <SurveyQuestion
      classes={props.classes ?? 'survey-component'}
      currQuestion={currQuestion}
      setCurrentQuestion={setCurrQuestion}
      questionsMapping={questionsMapping}
      setShowSurvey={props.setShowSurvey}
      primaryColor={props.primaryColor}
      surveyTextColor={props.surveyTextColor}
      source={props.source}
      surveyType={props.surveyType || ''}
      surveyPosition={props.surveyPosition || 0}
      submitAnswer={submitAnswer}
    />
  );
};

export default Survey;
